import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { AuthenticationService } from '../services/authentication.service';
import { SharedService } from '../services/shared.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  memberForm: FormGroup;
  membershipFees = [
    "Graded Rider as per DA's => R50-00",
    "Recreational member => Free",
    "Officials => Free"
  ];
  gender : [];

  constructor(private formBuilder: FormBuilder, private authService: AuthenticationService,
    private sharedService : SharedService) { }

  ngOnInit() {
    this.sharedService.GetGenders().subscribe((result: []) => {
      this.gender = result;
    });
    
    this.buildForm();
  }

  buildForm() {
    this.memberForm = this.formBuilder.group({
      userName :    new FormControl('', [Validators.required]),
      firstName:    new FormControl('', [Validators.required]),
      lastName:     new FormControl('', [Validators.required]),
      password:     new FormControl('',  [Validators.required]),
      email:        new FormControl('', [Validators.required]),
      mobileNumber: new FormControl('', [Validators.required]),
      membershipFees: new FormControl(0, [Validators.required]),
      dateOfBirth:    new FormControl('', [Validators.required]),
      genderId:       new FormControl('', [Validators.required]),
      saefRegistrationNumber :new FormControl(''),
      sanesaNo        :new FormControl(''),
      sawgaNo:new FormControl(''),
      sasaNo:new FormControl(''),
      dsaNo :new FormControl(''),
      sasjNo :new FormControl(''),
      saeqaNo:new FormControl(''),
      otherNo:new FormControl(''),
      terms :new FormControl(true),
      addDisciplineName     : new FormControl(''),
      addDisciplineNumber   : new FormControl('')
    });
  }

  register() {
    this.authService.register(this.memberForm.value);
  }


}
